export default "__VITE_ASSET__B7UwTqNe__"